var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("color: " + _vm.textColor + ";background: " + _vm.backgroundColor + ";height: " + (_vm.getHeight()))),attrs:{"id":"line"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }